module.exports = __webpack_public_path__ + "components/weather-icon/static/daymodrain-3a88b0bcfb1cde4d7ab48c1081a84774.svg";